import {
  getBranchesForCourse,
  getBranchesByInstitute,
  getWebexUserByBranch
} from './api'
import { branchSlice } from './reducer'

const { resetBranches } = branchSlice.actions

export {
  getBranchesForCourse,
  resetBranches,
  getBranchesByInstitute,
  getWebexUserByBranch
}
